module.exports = __webpack_public_path__ + "exo-latin-500italic.3cb9a625a9283be01425.woff2";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-500italic.woff2
// module id = ../../../../typeface-exo/files/exo-latin-500italic.woff2
// module chunks = styles